import { all_routes } from "../../../feature-module/router/all_routes";
import { useUserPermissions } from "../../../feature-module/UserPermissionsContext";
const routes = all_routes;

const SidebarData = () => {
  const { userPermissions } = useUserPermissions();

  const checkPermission = (action: string, subject: string) => {
    return userPermissions.some(
      (ability: { action: string; subject: string }) =>
        ability.action === action && ability.subject === subject
    );
  };

  return [
    {
      label: "Dashboard",
      icon: "ti ti-home",
      bgColor: "#e3f2fd",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        // { label: "Landing Page", link: routes.crmLandingPage},
        checkPermission("can_view_wizklub_dashboard", "Records") && { label: "Wizklub", icon: "ti ti-hexagonal-prism-plus", link: routes.adminDashboard1 },
        // checkPermission("view_trainer_dashboard", "Records") && { label: "Wizklub Trainer", icon: "ti ti-hexagonal-prism-plus", link: routes.wizklubTrainerDashboard },
        // checkPermission("can_view_summer_camp_dashboard", "Records") && { label: "Summercamp", icon: "ti ti-hexagonal-prism-plus", link: routes.adminDashboard },
        checkPermission("can_view_employee_dashboard", "Records") && { label: "Employee", icon: "ti ti-hexagonal-prism-plus", link: routes.employeeDashboard },
        // checkPermission("can_view_wizklub_new_dashboard", "Records") && { label: "Admin", icon: "ti ti-hexagonal-prism-plus", link: routes.wizklubDashboard },

      ].filter(Boolean),
    },
    {
      label: "User Management",
      submenuOpen: true,
      showSubRoute: false,
      icon: "ti ti-users",
      bgColor: "#f3e5f5",
      submenuHdr: "Academic",

      submenuItems: [
        checkPermission("view_group", "group") && {
          label: "Groups",
          icon: "ti ti-hexagonal-prism-plus",
          submenu: false,
          showSubRoute: false,
          link: routes.groups,
        },
        checkPermission("view_user", "user") && {
          label: "Users",
          icon: "ti ti-hexagonal-prism-plus",
          submenu: false,
          showSubRoute: false,
          link: routes.users,
        },


      ].filter(Boolean),
    },
    // {
    //   label: "Wizklub",
    //   submenuOpen: true,
    //   showSubRoute: false,
    //   submenuHdr: "Main",
    //   submenuItems: [
    //     {
    //       label: "Students",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,

    //       submenuItems: [
    //        {
    //           label: "Students Data",
    //           link: routes.studentData,
    //        }
    //       ]
    //     },
    //     {
    //       label: "Master Tables",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,
    //       submenuItems: [
    //         checkPermission("view", "Can view disposition") && {
    //           label: "Dispositions",
    //           link: routes.dispositions,
    //         },
    //         checkPermission("view", "Can view category") && {
    //           label: "Categories",
    //           link: routes.categories,
    //         },
    //         checkPermission("view", "Can view sub category") && {
    //           label: "Sub Categories",
    //           link: routes.subCategories,
    //         },
    //         checkPermission("view", "Can view priority") && {
    //           label: "Priorities",
    //           link: routes.priorities,
    //         },
    //         checkPermission("view", "Can view ticket status") && {
    //           label: "Ticket Status",
    //           link: routes.ticketStatus,
    //         },
    //         checkPermission("view", "Can view ticket type") && {
    //           label: "Type Of Ticket",
    //           link: routes.TypeOfTicket,
    //         },
    //       ].filter(Boolean),
    //     },
    //   ].filter(item => item.submenuItems && item.submenuItems.length > 0),
    // },
    {
      label: "Feedback Calling",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      icon: "ti ti-phone-call",
      bgColor: "#fff3e0",
      submenuItems: [

        {
          label: "Leads",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("can_assign_agent_to_summercamp_branch", "branchdetail") && {
              label: "Branches",
              link: routes.summerCampTeamLeadBranches,
            },
            checkPermission("view_student", "student") && {
              label: "Students",
              link: routes.SummerCampStudents,
            },
            checkPermission("view_student", "student") && {
              label: "Telangana Students",
              link: routes.SummerCampTelanganaStudents,
            },
            checkPermission("view_summercampticket", "summercampticket") && {
              label: "Follow Ups",
              link: routes.SummerCampCallBacks,
            },
            checkPermission("view_agentsaletarget", "agentsaletarget") && {
              label: "Dailed",
              link: routes.summerCampCompletedTargets,
            },

            checkPermission("view_pendingsummercampenrollment", "pendingsummercampenrollment") && {
              label: "Pending Enrollments",
              link: routes.SummerCampPendingEnrollments,
            },
            checkPermission("get_students_by_phone_number", "student") && {
              label: "Find Student",
              link: routes.phoneNumberToStudent,
            },
            checkPermission("get_students_by_phone_number", "student") && {
              label: "SMS",
              link: routes.smstoStudent,
            },
          ].filter(Boolean),
        },
        {
          label: "Masters",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_summercampcategory", "summercampcategory") && {
              label: "Categories",
              link: routes.SummerCampCategories,
            },
            checkPermission("view_summercampsubcategory", "summercampsubcategory") && {
              label: "Sub Categories",
              link: routes.SummerCampSubCategories,
            },
            checkPermission("can_assign_team_lead_to_summer_camp_branch", "branchdetail") && {
              label: "Branches",
              link: routes.summercampBranchesManager,
            },
          ].filter(Boolean),
        },
        {
          label: "Reports",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("agent_call_summary", "Records") && {
              label: "Agent Call Summary",
              link: routes.agentCallSummary,
            },
            // checkPermission("agent_call_summary", "Records") && {
            //   label: "Sc And Non-Sc Agent Call Summary",
            //   link: routes.summercampScAndNonScAgentCallSummary,
            // },
            checkPermission("can_view_summer_camp_hourly_call_report", "calllog") && {
              label: "Hourly Report",
              link: routes.summmerCampHourlyReport,
            },
            // checkPermission("view_summercampticketsales", "summercampticketsales") && {
            //   label: "Sales",
            //   link: routes.agentWiseStudentSales,
            // },
            // checkPermission("view_summer_camp_agent_report", "Records") && {
            //   label: "CVR",
            //   link: routes.SummerCampAgentReports,
            // },
            checkPermission("can_view_summer_camp_overall_call_log", "calllog") && {
              label: "Call Logs",
              link: routes.summercampCallLogs,
            },
          ].filter(Boolean),
        },
      ].filter((item) => item.submenuItems && item.submenuItems.length > 0),
    },

    // {
    //   label: "Non Chaitanya",
    //   submenuOpen: true,
    //   showSubRoute: false,
    //   submenuHdr: "Main",
    //   submenuItems: [
    //     {
    //       label: "Leads  ",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,
    //       submenuItems: [
    //         checkPermission("can_assign_agent_od_targets", "odagentsaletarget") && {
    //           label: "Students",
    //           link: routes.NonChaiatnyaSummerCampStudents,
    //         },
    //         checkPermission("view_odagentsaletarget", "odagentsaletarget") && {
    //           label: "Targets",
    //           link: routes.NonChaitanyaAgentTargets,
    //         },
    //         checkPermission("view_odticket", "odticket") && {
    //           label: "Follow Ups",
    //           link: routes.NonChaitanyaSummerCampCallBacks,
    //         },
    //         checkPermission("view_odticket", "odticket") && {
    //           label: "Dailed",
    //           link: routes.NonChaitanyaSummerCampCompletedTargets,
    //         },
    //         // checkPermission("view_agentsaletarget", "agentsaletarget") && {
    //         //   label: "Dailed",
    //         //   link: routes.summerCampCompletedTargets,
    //         // },
    //         // checkPermission("view_summercampticketsales", "summercampticketsales") && {
    //         //   label: "Agent Wise Student Sales",
    //         //   link: routes.agentWiseStudentSales,
    //         // },
    //         // checkPermission("get_students_by_phone_number", "student") && {
    //         //   label: "Find Student",
    //         //   link: routes.phoneNumberToStudent,
    //         // },
    //       ].filter(Boolean),
    //     },
    //     {
    //       label: "Masters  ",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,
    //       submenuItems: [
    //         checkPermission("view_odcategory", "odcategory") && {
    //           label: "Categories",
    //           link: routes.NonChaitanyaCategories,
    //         },
    //         checkPermission("view_odsubcategory", "odsubcategory") && {
    //           label: "Sub Categories",
    //           link: routes.NonChaitanyaSubCategories,
    //         },
    //         // checkPermission("can_assign_team_lead_to_summer_camp_branch", "branchdetail") && {
    //         //   label: "Branches",
    //         //   link: routes.summercampBranchesManager,
    //         // },
    //       ].filter(Boolean),
    //     },
    //     {
    //       label: "Reports  ",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,
    //       submenuItems: [
    //         checkPermission("agent_od_call_summary", "Records") && {
    //           label: "Agent Call Summary",
    //           link: routes.NonChaitanyaAgentCallSummary,
    //         },
    //         checkPermission("can_view_od_hourly_call_report", "calllog") && {
    //           label: "Hourly Report",
    //           link: routes.NonChaitanyaHourlyReport,
    //         },
    //         checkPermission("view_odticketsales", "odticketsales") && {
    //           label: "Sales",
    //           link: routes.NonChaitanyaSales,
    //         },
    //         checkPermission("can_view_od_overall_call_log", "calllog") && {
    //           label: "Call Logs",
    //           link: routes.nonChaitanyaCallLogs,
    //         },
    //       ].filter(Boolean),
    //     },
    //   ].filter((item) => item.submenuItems && item.submenuItems.length > 0),
    // },


    {
      label: "WizKlub",
      submenuOpen: true,
      showSubRoute: false,
      icon: "ti ti-school",
      bgColor: "#e8f5e9",
      submenuHdr: "Main1",
      submenuItems: [
        {
          label: "Student Details ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,

          submenuItems: [
            checkPermission("can_assign_agent_to_wizklub_branch", "branchdetail") && {
              label: "Agent Branch Assignment",
              link: routes.wizklubBranchesTeamLead,
            },
            checkPermission("view_wizklub_students", "student") && {
              label: "Students",
              link: routes.wizklubStudents,
            },
            // checkPermission("view_agentsaletarget", "agentsaletarget") && {
            //   label: "Targets",
            //   link: routes.agentTargets,
            // },
            checkPermission("view_wizklub_followups", "wizklubticket") && {
              label: "Follow Ups",
              link: routes.wizklubCallBacks,
            },
            checkPermission("view_previousyearswizklubpaidstudents", "previousyearswizklubpaidstudents") && {
              label: "Renewals(2025-2026)",
              link: routes.wizklubPreviousYearPaidStudents,
            },
            checkPermission("view_previousyearswizklubpaidstudents", "previousyearswizklubpaidstudents") && {
              label: "Renewals(2024-2025)",
              link: routes.wizklubOneYearPreviousYearStudents,

            },
            checkPermission("view_dailed_student", "student") && {
              label: "Dailed",
              link: routes.wizklubCompletedStudents,
            },
            //  checkPermission("can_view_wizklub_trainer_branches", "branch") && {
            //   label: "Trainer Branches",
            //   link: routes.wizklubTrainerBranches,
            // },
            checkPermission("get_students_by_phone_number", "student") && {
              label: "Find Student",
              link: routes.phoneNumberToStudent,
            },

            checkPermission("can_view_wizklub_sales_display", "custom_model") && {
              label: "Sales Display",
              link: routes.wizklubSalesDisplay,
            },
            // checkPermission("view_agentsaletarget", "agentsaletarget") && {
            //   label: "Completed Targets",
            //   link: routes.summerCampCompletedTargets,
            // },
            // checkPermission("view_summercampticketsales", "summercampticketsales") && {
            //   label: "Agent Wise Student Sales",
            //   link: routes.agentWiseStudentSales,
            // },
            // checkPermission("view_branchdetail", "branchdetail") && {
            //   label: "Branches",
            //   link: routes.BranchesWizclubOrnot,
            // },
            // {
            //   label: "Leaderboard",
            //   link: routes.leaderboard,
            // },
          ].filter(Boolean),
        },
        {
          label: "Masters ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            // checkPermission("view", "Can view disposition") && {
            //   label: "Dispositions",
            //   link: routes.SummerCampDisposition,
            // },
            // checkPermission("view", "Can view category") &&
            checkPermission("view_wizklubcategory", "wizklubcategory") && {
              label: "Categories",
              link: routes.wizklubCategories,
            },
            // checkPermission("view", "Can view sub category") &&
            checkPermission("view_wizklubsubcategory", "wizklubsubcategory") && {
              label: "Sub Categories",
              link: routes.wizklubSubCategories,
            },
            checkPermission("can_assign_team_lead_to_wizklub_branch", "branchdetail") && {
              label: "Branches Assigment to Team Lead",
              link: routes.wizklubBranchesManager,
            },
            checkPermission("view_branchdetail", "branchdetail") && {
              label: "Branches",
              link: routes.BranchesWizclubOrnot,
            },
            checkPermission("view_wizklubsaletarget", "wizklubsaletarget") && {
              label: "Sale Target",
              link: routes.wizklubAssignBranchTarget,
            },
            checkPermission("assign_branch_category", "branchdetail") && {
              label: "Branch Category",
              link: routes.wizklubAssignBranchCategory,
            },
            checkPermission("view_agentsdailyattendance", "agentsdailyattendance") && {
              label: "Attendance",
              link: routes.wizklubAgentsAttendance,
            },
            // checkPermission("view", "Can view priority") &&
            // checkPermission("view_summercamppriority", "summercamppriority") && {
            //   label: "Priorities",
            //   link: routes.SummerCampPriorities,
            // },
            // checkPermission("view_group", "group") && {
            //   label: "Ticket Status",
            //   link: routes.SummerCampTicketStatus,
            // },
          ].filter(Boolean),
        },
        {
          label: " Reports",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("agent_wizklub_call_summary", "Records") && {
              label: "Agent Call Summary",
              link: routes.wizklubAgentCallSummary,
            },
            checkPermission("view_wizklubticketsales", "wizklubticketsales") && {
              label: "Sales",
              link: routes.wizklubSales,
            },
            checkPermission("view_wizklubsales_oncall_analytics", "wizklubticketsales") && {
              label: "Sales Analytics",
              link: routes.wizklubSalesAnalytics,
            },
            checkPermission("can_view_hourly_call_report", "calllog") && {
              label: "Hourly Report",
              link: routes.wizklubHourlyReport,
            },
            checkPermission("can_view_wizklub_overall_call_log", "calllog") && {
              label: "Call Logs",
              link: routes.wizklubCallLogs,
            },
            checkPermission("view_wizklubbranchwisesalesstudentdetails", "wizklubbranchwisesalesstudentdetails") && {
              label: "Branch wise Sale Details",
              link: routes.wizklubBranchWiseSaleData,
            },

            checkPermission("view_wizklubbranchwisecallbackstudentdetails", "wizklubbranchwisecallbackstudentdetails") && {
              label: "Branch wise Call Back Details",
              link: routes.wizklubBranchWiseCallBackData,
            },
            checkPermission("change_wizklubbranchwiseinterestedstudentsdetails", "wizklubbranchwiseinterestedstudentsdetails") && {
              label: "Branch wise Intrested Details",
              link: routes.wizklubBranchWiseIntrestedata,
            },
            checkPermission("view_wizklubbranchwiseconnetedstudentdetails", "wizklubbranchwiseconnetedstudentdetails") && {
              label: "Branch wise Connected Details",
              link: routes.wizklubBranchWiseConnectedData,
            },
            checkPermission("view_wizklubbranchwisenotinterestedstudentdetails", "wizklubbranchwisenotinterestedstudentdetails") && {
              label: "Branch wise Not Intrested Details",
              link: routes.wizklubBranchWiseNotIntrestedData,
            },
            //  checkPermission("can_view_unique_lead_report", "custom_model") && {
            //   label: "Branch Unique Lead Touch",
            //   link: routes.wizklubBranchUniqueLeadTouch,
            // },
          ].filter(Boolean),
        },

        {
          label: " Inputs & CVR",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_wizklub_agent_report", "Records") && {
              label: "CVR",
              link: routes.wizklubAgentReports,
            },
            checkPermission("view_wizklub_agent_report", "Records") && {
              label: "Branch DetailCVR",
              link: routes.wizklubBranchDetailCvr,
            },
            checkPermission("view_cvr_inputs", "Records") && {
              label: "Agent Inputs",
              link: routes.wizklubInputs,
            },
            checkPermission("view_wizklub_branch_cvr", "Records") && {
              label: "Branch CVR",
              link: routes.wizklubBranchCvr,
            },
          ].filter(Boolean),
        },
        {
          label: " Targets",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_dailycallconversion", "dailycallconversion") && {
              label: "Daily Conversation",
              link: routes.wizklubDailyTargets,
            },

            checkPermission("view_agentdailysalestarget", "agentdailysalestarget") && {
              label: "Daily Sales",
              link: routes.wizklubDailySalesTaarget,
            },

            // checkPermission("view_weeklysales", "weeklysales") && {
            //   label: "Weekly Targets",
            //   link: routes.wizklubWeeklySales,
            // },
          ].filter(Boolean),
        },
        // {
        //   label: "Reports",
        //   icon: "ti ti-layout-dashboard",
        //   submenu: true,
        //   showSubRoute: false,
        //   submenuItems: [
        //     // checkPermission("view", "Can view disposition") && {
        //     //   label: "Dispositions",
        //     //   link: routes.SummerCampDisposition,
        //     // },
        //     // checkPermission("view", "Can view category") &&
        //     checkPermission("agent_call_summary", "Records") && {
        //       label: "Agent Call Summary",
        //       link: routes.agentCallSummary,
        //     },
        //     checkPermission("view_summercampticketsales", "summercampticketsales") && {
        //       label: "Agent Target Status",
        //       link: routes.agentWiseTargetStatus,
        //     },
        //   ].filter(Boolean),
        // },
        // {
        //   label: "Team Management ",
        //   icon: "ti ti-layout-dashboard",
        //   submenu: true,
        //   showSubRoute: false,
        //   submenuItems: [
        //     // checkPermission("view", "Can view disposition") && {
        //     //   label: "Dispositions",
        //     //   link: routes.SummerCampDisposition,
        //     // },
        //     // checkPermission("view", "Can view category") &&
        //     checkPermission("view_teammanagement", "teammanagement") && {
        //       label: "Team management List",
        //       link: routes.teamManagementList,
        //     },
        //     checkPermission("view_agentgrouptype", "agentgrouptype") && {
        //       label: "Agent Group Types",
        //       link: routes.agentGroupTypesList,
        //     },
        //     checkPermission("view_agentgroup", "agentgroup") && {
        //       label: "Agent Groups",
        //       link: routes.agentGroupsList,
        //     },
        //   ].filter(Boolean),
        // },

      ].filter((item) => item.submenuItems && item.submenuItems.length > 0),
    },

    // {
    //   label: "Prism",
    //   submenuOpen: true,
    //   showSubRoute: false,
    //   icon: "ti ti-building",
    //   bgColor: "#fce4ec",
    //   submenuHdr: "Prism",
    //   submenuItems: [
    //     {
    //       label: "Leads                                             ",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,

    //       submenuItems: [
    //         checkPermission("view_schoollead", "schoollead") && {
    //           label: "Pending Leads",
    //           link: routes.prismPendingLeads,
    //         },
    //         checkPermission("view_schoollead", "schoollead") && {
    //           label: "Completed Leads",
    //           link: routes.prismCompletedLeads,
    //         },
    //       ].filter(Boolean),
    //     },
    //     {
    //       label: "Masters                                      ",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,
    //       submenuItems: [
    //         checkPermission("view_schoolticketcategory", "schoolticketcategory") && {
    //           label: "Categories",
    //           link: routes.prisamCategories,
    //         },
    //         checkPermission("view_schoolticketsubcategory", "schoolticketsubcategory") && {
    //           label: "Sub Categories",
    //           link: routes.prisamSubCategories,
    //         },
    //         checkPermission("view_schoolleadteammgmt", "schoolleadteammgmt") && {
    //           label: "Team Management",
    //           link: routes.prismTeamManagement,
    //         },
    //       ].filter(Boolean),
    //     },
    //     {
    //       label: "Reports        ",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,
    //       submenuItems: [
    //         checkPermission("agent_prism_call_summary", "Records") && {
    //           label: "Agent Call Summary",
    //           link: routes.prismAgentCallSummary,
    //         },
    //         // checkPermission("can_view_call_participant_hourly_call_report", "Records") && {
    //         //   label: "Hourly Report",
    //         //   link: routes.prismHourlyReport,
    //         // },
    //         // checkPermission("view_summercampticketsales", "summercampticketsales") && {
    //         //   label: "Sales",
    //         //   link: routes.agentWiseStudentSales,
    //         // },
    //         // checkPermission("view_summer_camp_agent_report", "Records") && {
    //         //   label: "CVR",
    //         //   link: routes.SummerCampAgentReports,
    //         // },
    //         checkPermission("can_view_prism_overall_call_logs", "calllog") && {
    //           label: "Call Logs",
    //           link: routes.prismOverAllCallLogs,
    //         },
    //       ].filter(Boolean),
    //     },
    //   ].filter((item) => item.submenuItems && item.submenuItems.length > 0),
    // },



    {
      label: "WizKlub Trainers",
      submenuOpen: true,
      showSubRoute: false,
      icon: "ti ti-user-share",
      bgColor: "#f9fbe7",
      submenuHdr: "Main1",
      submenuItems: [
        {
          label: "Student Details     ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,

          submenuItems: [
            checkPermission("view_wizklubtrainerassignment", "wizklubtrainerassignment") && {
              label: "Wizklub Trainer Assignment",
              icon: "ti ti-hexagonal-prism-plus",
              submenu: false,
              showSubRoute: false,
              link: routes.wizklubTrainerAssignmentToManager,
            },
            checkPermission("can_view_wizklub_trainer_branches", "branch") && {
              label: "Trainer Branches",
              link: routes.wizklubTrainerBranches,
            },
            checkPermission("can_view_wizklub_trainer_branches", "branch") && {
              label: "Follow Up Branches",
              link: routes.wizklubTrainerFollowUpBranches,
            },
            checkPermission("can_view_wizklub_trainer_branches", "branch") && {
              label: "Dailed Branches",
              link: routes.wizklubTrainerDailedBranches,
            },
          ].filter(Boolean),
        },
        {
          label: " Reports      ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("can_view_wizklub_trainer_sales", "wizklubticketsales") && {
              label: "Sales",
              link: routes.wizklubTrainerSales,
            },
            checkPermission("can_view_wizklub_trainer_call_log", "calllog") && {
              label: "Call Logs",
              link: routes.wizklubTrainerCallLogs,
            },

          ].filter(Boolean),

        },
        checkPermission("view_seminarorientation", "seminarorientation") && {
          label: "Orientations",
          icon: "ti ti-hexagonal-prism-plus",
          submenu: false,
          showSubRoute: false,
          link: routes.seminors,
        },

      ].filter(Boolean),
    },
    // {
    //   label: "Seminars",
    //   submenuOpen: true,
    //   showSubRoute: false,
    //   icon: "ti ti-presentation",
    //   bgColor: "#edeff2",
    //   submenuHdr: "Academic",

    //   submenuItems: [
    //     checkPermission("view_seminarorientation", "seminarorientation") && {
    //       label: "Seminars",
    //       icon: "ti ti-hexagonal-prism-plus",
    //       submenu: false,
    //       showSubRoute: false,
    //       link: routes.seminors,
    //     },
    //   ].filter(Boolean),
    // },
    {
      label: "Employee",
      submenuOpen: true,
      showSubRoute: false,
      icon: "ti ti-user-star",
      bgColor: "#ede7f6",
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Employee Details                             ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_teacher", "teacher") && {
              label: "Employees",
              link: routes.employeeDetails,
            },
            checkPermission("view_teacher", "teacher") && {
              label: "Dailed Employees",
              link: routes.employeeDailed,
            },
            // checkPermission("view_teacher", "teacher") && {
            //   label: "Pending Employees",
            //   link: routes.pendingEmployeeDetails,
            // },
            // checkPermission("view_teacher", "teacher") && {
            //   label: "Completed Employees",
            //   link: routes.completedEmployeeDetails,
            // },
            // checkPermission("view_student", "student") && {
            //   label: "Students",
            //   link: routes.SummerCampStudents,
            // },
            // checkPermission("view_student", "student") && {
            //   label: "Telangana Students",
            //   link: routes.SummerCampTelanganaStudents,
            // },
            // checkPermission("view_summercampticket", "summercampticket") && {
            //   label: "Follow Ups",
            //   link: routes.SummerCampCallBacks,
            // },
            // checkPermission("view_agentsaletarget", "agentsaletarget") && {
            //   label: "Dailed",
            //   link: routes.summerCampCompletedTargets,
            // },

            // checkPermission("view_pendingsummercampenrollment", "pendingsummercampenrollment") && {
            //   label: "Pending Enrollments",
            //   link: routes.SummerCampPendingEnrollments,
            // },
            // checkPermission("get_students_by_phone_number", "student") && {
            //   label: "Find Student",
            //   link: routes.phoneNumberToStudent,
            // },
          ].filter(Boolean),
        },
        {
          label: "Masters                            ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_employeecallingbranchassignment", "employeecallingbranchassignment") && {
              label: "Branch Assignment",
              link: routes.employeeBranchAssignment,
            },
            checkPermission("view_teacherrolegroup", "teacherrolegroup") && {
              label: "Teacher Role Group",
              link: routes.teacherRole,
            },
            checkPermission("view_servicedivision", "servicedivision") && {
              label: "Service Division",
              link: routes.employeeServiceDivision,
            },
            checkPermission("view_teacherticketcategory", "teacherticketcategory") && {
              label: "Categories",
              link: routes.employeeCategories,
            },
            checkPermission("view_teacherticketsubcategory", "teacherticketsubcategory") && {
              label: "Sub Categories",
              link: routes.employeeSubCategories,
            },
            checkPermission("view_employeesuserteammanagement", "employeesuserteammanagement") && {
              label: "Employee Teams",
              icon: "ti ti-hexagonal-prism-plus",
              submenu: false,
              showSubRoute: false,
              link: routes.employeeTeamManagment,
            },
            checkPermission("view_employees_team_members", "employeesuserteammanagement") && {
              label: "Team Members",
              icon: "ti ti-hexagonal-prism-plus",
              submenu: false,
              showSubRoute: false,
              link: routes.employeeUsers,
            },
            // checkPermission("view_empworkassignment", "empworkassignment") && {
            //   label: "Work Assignment",
            //   link: routes.employeeWorkAssignment,
            // },
            checkPermission("upload_infinityteacherlogimdata", "infinityteacherlogimdata") && {
              label: "Meta Login Details Upload",
              link: routes.metaEmployeeLoginDetailsUpload,
            },
          ].filter(Boolean),
        },
        {
          label: "Reports",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("agent_employee_call_summary", "Records") && {
              label: "Agent Call Summary",
              link: routes.employeeAgentCallSummary,
            },
            checkPermission("can_view_employee_hourly_call_report", "calllog") && {
              label: "Hourly Report",
              link: routes.employeeHourlyReport,
            },
            checkPermission("can_view_employee_overall_call_log", "calllog") && {
              label: "Call Logs",
              link: routes.employeecallLogs,
            },
          ].filter(Boolean),
        },
      ].filter((item) => item.submenuItems && item.submenuItems.length > 0),
    },

    {
      label: "Employee Task",
      submenuOpen: true,
      showSubRoute: false,
      icon: "ti ti-checklist",
      bgColor: "#fff8e1",
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Employee Details",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_teacher_for_emp_work_assign", "teacher") && {
              label: "Pending Task",
              link: routes.pendingEmployeeDetails,
            },
            checkPermission("view_teacher_for_emp_work_assign", "teacher") && {
              label: "Completed Task",
              link: routes.completedEmployeeDetails,
            },
          ].filter(Boolean),
        },
        {
          label: "Masters        ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_empworkassignment", "empworkassignment") && {
              label: "Work Assignment",
              link: routes.employeeWorkAssignment,
            },
          ].filter(Boolean),
        },
      ].filter((item) => item.submenuItems && item.submenuItems.length > 0),
    },

    // {
    //   label: "Score",
    //   submenuOpen: true,
    //   showSubRoute: false,
    //   icon: "ti ti-chart-bar",
    //   bgColor: "#e0f7fa",
    //   submenuHdr: "Main",
    //   submenuItems: [
    //     {
    //       label: "Branch Details",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,
    //       submenuItems: [
    //         checkPermission("can_view_score_dailed_employees", "teacher") && {
    //           label: "Branches For Employee",
    //           link: routes.scoreEmployeeBranches,
    //         },
    //         checkPermission("can_view_score_employees", "teacher") && {
    //           label: "Branches Dailed Employees",
    //           link: routes.scoreDailedEmployeeBranches,
    //         },
    //         // checkPermission("view_student", "student") && {
    //         //   label: "Students",
    //         //   link: routes.SummerCampStudents,
    //         // },
    //         // checkPermission("view_student", "student") && {
    //         //   label: "Telangana Students",
    //         //   link: routes.SummerCampTelanganaStudents,
    //         // },
    //         // checkPermission("view_summercampticket", "summercampticket") && {
    //         //   label: "Follow Ups",
    //         //   link: routes.SummerCampCallBacks,
    //         // },
    //         // checkPermission("view_agentsaletarget", "agentsaletarget") && {
    //         //   label: "Dailed",
    //         //   link: routes.summerCampCompletedTargets,
    //         // },

    //         // checkPermission("view_pendingsummercampenrollment", "pendingsummercampenrollment") && {
    //         //   label: "Pending Enrollments",
    //         //   link: routes.SummerCampPendingEnrollments,
    //         // },
    //         // checkPermission("get_students_by_phone_number", "student") && {
    //         //   label: "Find Student",
    //         //   link: routes.phoneNumberToStudent,
    //         // },
    //       ].filter(Boolean),
    //     },
    //     // {
    //     //   label: "Masters        ",
    //     //   icon: "ti ti-layout-dashboard",
    //     //   submenu: true,
    //     //   showSubRoute: false,
    //     //   submenuItems: [
    //     //     checkPermission("view_servicedivision", "servicedivision") && {
    //     //       label: "Service Division",
    //     //       link: routes.employeeServiceDivision,
    //     //     },
    //     //     checkPermission("view_teacherticketcategory", "teacherticketcategory") && {
    //     //       label: "Categories",
    //     //       link: routes.employeeCategories,
    //     //     },
    //     //     checkPermission("view_teacherticketsubcategory", "teacherticketsubcategory") && {
    //     //       label: "Sub Categories",
    //     //       link: routes.employeeSubCategories,
    //     //     },
    //     //   ].filter(Boolean),
    //     // },
    //     {
    //       label: "Reports                      ",
    //       icon: "ti ti-layout-dashboard",
    //       submenu: true,
    //       showSubRoute: false,
    //       submenuItems: [
    //         checkPermission("view_scorebranchcallingagentsreports", "scorebranchcallingagentsreports") && {
    //           label: "Branch Calling Reports",
    //           link: routes.scoreReports,
    //         },
    //       ].filter(Boolean),
    //     },
    //   ].filter((item) => item.submenuItems && item.submenuItems.length > 0),
    // },


    {
      label: "Call Participant",
      submenuOpen: true,
      showSubRoute: false,
      icon: "ti ti-phone",
      bgColor: "#f1f8e9",
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Leads   ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_callparticipant", "callparticipant") && {
              label: "Pending List",
              link: routes.callParticipantList,
            },
            checkPermission("view_callparticipant", "callparticipant") && {
              label: "Completed List",
              link: routes.CompletedCallParticipantList,
            },
          ].filter(Boolean),
        },
        {
          label: "Masters   ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("view_callparticipantticketcategory", "callparticipantticketcategory") && {
              label: "Categories",
              link: routes.callParticipantCategories,
            },
            checkPermission("view_callparticipantticketsubcategory", "callparticipantticketsubcategory") && {
              label: "Sub Categories",
              link: routes.callParticipantSubCategories,
            },
          ].filter(Boolean),
        },
        {
          label: "Reports      ",
          icon: "ti ti-layout-dashboard",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            checkPermission("can_view_call_participant_call_summary", "Records") && {
              label: "Agent Call Summary",
              link: routes.callParticipantAgentCallSummary,
            },
            checkPermission("can_view_call_participant_hourly_call_report", "Records") && {
              label: "Hourly Report",
              link: routes.callParticipantHourlyReport,
            },
            // checkPermission("view_summercampticketsales", "summercampticketsales") && {
            //   label: "Sales",
            //   link: routes.agentWiseStudentSales,
            // },
            // checkPermission("view_summer_camp_agent_report", "Records") && {
            //   label: "CVR",
            //   link: routes.SummerCampAgentReports,
            // },
            checkPermission("can_view_call_participant_overall_call_log", "Records") && {
              label: "Call Logs",
              link: routes.callParticipantcallLogs,
            },
          ].filter(Boolean),
        },
      ].filter((item) => item.submenuItems && item.submenuItems.length > 0),
    },
    {
      label: "Team Management",
      submenuOpen: true,
      showSubRoute: false,
      icon: "ti ti-user-cog",
      bgColor: "#fbe9e7",
      submenuHdr: "Main1",
      submenuItems: [

        // checkPermission("view", "Can view disposition") && {
        //   label: "Dispositions",
        //   link: routes.SummerCampDisposition,
        // },
        // checkPermission("view", "Can view category") &&
        checkPermission("view_teammanagement", "teammanagement") && {
          label: "Team management List",
          link: routes.teamManagementList,
        },
        checkPermission("view_agentgrouptype", "agentgrouptype") && {
          label: "Agent Group Types",
          link: routes.agentGroupTypesList,
        },
        checkPermission("view_agentgroup", "agentgroup") && {
          label: "Agent Groups",
          link: routes.agentGroupsList,
        },




      ].filter(Boolean),
    },
  ];
};

export default SidebarData;
